// Swatch hover preview helper.
// Handles ONLY hover — variant selection image management is owned by product-information.liquid.
// Scoped to .product-information__media to avoid touching other products on the page.

(function () {
  'use strict';

  function getFormattedUrl(url) {
    if (!url) return null;
    const temp = document.createElement('div');
    temp.innerHTML = url;
    let decoded = temp.textContent || temp.innerText || url;
    decoded = decoded.replace(/&amp;/g, '&');
    if (decoded.startsWith('//')) {
      decoded = 'https:' + decoded;
    }
    return decoded;
  }

  function enforceImage(img, url) {
    if (!url) return false;
    const correctUrl = getFormattedUrl(url);
    if (!correctUrl) return false;
    if (img.src !== correctUrl) {
      img.src = correctUrl;
      img.srcset = correctUrl;
      return true;
    }
    return false;
  }

  function highResUrlForVariant(variantId) {
    if (!variantId || !window.variantMetafields) return null;
    const meta = window.variantMetafields[variantId];
    if (!meta) return null;
    if (meta.variant_images?.length > 0 && meta.variant_images[0]?.value) {
      return meta.variant_images[0].value;
    }
    if (meta.images?.length > 0 && meta.images[0]?.url) {
      return meta.images[0].url;
    }
    return null;
  }

  function variantIdFromEventDetail(detail) {
    if (!detail || typeof detail !== 'object') return undefined;
    return (
      detail.variantID ??
      detail.variantId ??
      detail.variant?.id ??
      (typeof detail.id === 'string' || typeof detail.id === 'number' ? detail.id : undefined)
    );
  }

  document.addEventListener('swatch:hover', function (event) {
    const variantId = variantIdFromEventDetail(event.detail);
    if (!variantId) return;

    const highResUrl = highResUrlForVariant(variantId);
    if (!highResUrl) return;

    // Scope to this product only — prevents cross-product contamination.
    const container = document.querySelector('.product-information__media');
    if (!container) return;

    // Flag tells product-information.liquid's imageObserver to ignore this src change.
    window._swatchHoverActive = true;

    requestAnimationFrame(function () {
      const images = container.querySelectorAll('.product-media__image[data_max_resolution]');
      images.forEach(function (img) {
        const slide = img.closest('slideshow-slide');
        const isHidden = slide && (slide.hasAttribute('hidden') || slide.getAttribute('aria-hidden') === 'true');
        if (!isHidden || !slide) {
          enforceImage(img, highResUrl);
        }
      });

      // Clear flag after paint so imageObserver resumes for real variant changes.
      requestAnimationFrame(function () {
        window._swatchHoverActive = false;
      });
    });
  });
})();
